module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/arrow-left-line-6577e9fbd7edc09666809ca0ad705179.svg";